import React, { useState, useMemo, forwardRef, useCallback, useEffect } from 'react';
import { Form } from 'antd'
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes, parseSelectOptions } from 'utils/formUtils';
import GenericMappingForm from '../GenericMappingForm';

const SpectralMappingForm = forwardRef((props, ref) => {
  const [options, setOptions] = useState(() => {
    if (props.record) {
      const { assetId } = props.record;
      const repositoryNameArray = assetId.split(',');
      return repositoryNameArray.map(value => ({ id: value, name: value }))
    }
    return [];
  });
  const [form] = Form.useForm();

  const getExtraFieldsData = (config) => {
    const { assetId } = config;
    const data = options.reduce((acc, cv) => {
      const { id, name } = cv;

      if (assetId.includes(id)) {
        acc.name.push(name);
      }
      return acc;
    }, { name: [] })

    return ({
      assetId: data.name.join()
    });
  };

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    return {
      assetId: config.assetId ? config.assetId.split(',') : undefined,
    };
  }, []);

  useEffect(() => {
    const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
    promise.then((response) => {
      const { projects } = response;
      setOptions(projects);
    })

    return cancel;
  }, [props.loginConfigId,props.toolName]);

  const extraFields = useMemo(() => ([
    {
      name: 'assetId',
      colSpan: '10',
      type: FieldTypes.MULTI_SELECT,
      label: 'Assets',
      options: parseSelectOptions(options),
      props: {
        autoFocus: true,
      },
      required: true
    }
  ]), [options]);


  return (
    <GenericMappingForm
      form={form}
      ref={ref}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      {...props}
    />
  )
})

export default SpectralMappingForm;